import { message } from 'antd';
import { takeLatest, put } from 'redux-saga/effects';
import { logger } from 'services';
import { updateDocumentTemplateResourceSectionAction } from '../../actions';
import { updateDocumentResourceSection } from '../../slices';
import { saveDocumentTemplate } from '../_save-template';
function* updateDocumentTemplateResourceSection(action) {
    const { payload: { docId, resource } } = action;
    try {
        yield put(updateDocumentResourceSection({
            docId,
            resource
        }));
        yield saveDocumentTemplate(docId);
    } catch (error) {
        logger.error('updateDocumentTemplateResourceSection failed ', {
            error
        });
        yield message.error('There was an error creating a task in the document');
    }
}
export const watchUpdateDocumentTemplateResourceSectionSaga = function*() {
    yield takeLatest(updateDocumentTemplateResourceSectionAction.type, updateDocumentTemplateResourceSection);
};
